import script from "./ow-users-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-users-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-users-form.vue?vue&type=style&index=0&id=725080ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-725080ec"]])

export default __exports__